import React from 'react';
import './Css/About.css'

const About = () => {
  return (
    <>

      <div className='container-fluid' id='About'>
        <div className='row'>
          <div className='col'>
            <p className='text-white display-6 text-uppercase'>about us </p>
          </div>
        </div>
      </div>

    </>
  )
}

export default About;